import React from 'react';
import moment from 'moment';
import { Archive } from 'react-feather';
import { Grid, SvgIcon } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { Link as RouterLink } from 'react-router-dom';

import ErrorBoundary from 'src/components/ErrorBoundary';
import { Engagement } from 'src/types';
import Content from 'src/components/Content';
import Button from 'src/components/Button';
import Activities from 'src/views/shared/Activities';
import RoleAssignmentsCard from 'src/views/shared/RoleAssignmentsCard';
import TasksCard from 'src/views/shared/TasksCard';

import EngagementProcess from './EngagementProcess';
import Record from '../Record';

function Overview({ engagement }: { engagement: Engagement }) {
  const actions = (
    <Button component={RouterLink} to={`/workflows/${engagement.workflow.id}/dashboard`}>
      Go to workflow
    </Button>
  );

  return (
    <ErrorBoundary>
      <Content
        title={`${engagement.workflow.name}: #${engagement.name}`}
        actions={actions}
        maxWidth="lg"
        breadcrumbs={[
          {
            title: 'Engagements',
            route: '/engagements',
          },
        ]}
      >
        <Grid container spacing={3}>
          {
            engagement.archivedDatetime && (
              <Grid item xs={12}>
                <Alert
                  severity="warning"
                  icon={(
                    <SvgIcon fontSize="small">
                      <Archive />
                    </SvgIcon>
                  )}
                  action={(
                    <Button color="inherit" size="small">
                      Unarchive
                    </Button>
                  )}
                >
                  This engagement was archived on {moment(engagement.archivedDatetime).format('llll')}
                </Alert>
              </Grid>
            )
          }
          <Grid item xs={12} lg={6}>
            <EngagementProcess
              workflowId={engagement.workflow.id}
              engagementId={engagement.id}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <RoleAssignmentsCard
              engagementId={engagement.id}
              workflowId={engagement.workflow.id}
            />
          </Grid>
          <Grid item xs={12}>
            <TasksCard
              seeAllRoute={`/engagements/${engagement.id}/tasks`}
              url={`/automatic/engagements/${engagement.id}/tasks/`}
              title="Outstanding tasks"
            />
          </Grid>
          <Grid item xs={6}>
            <Activities
              title="Events"
              url={`/automatic/engagements/${engagement.id}/events/`}
            />
          </Grid>
          <Grid item xs={6}>
            <Record engagementId={engagement.id} workflowId={engagement.workflow.id} />
          </Grid>
        </Grid>
      </Content>
    </ErrorBoundary>
  );
}

export default Overview;
